import { Component } from '@angular/core';
import { NavigationItem } from './navigation_item';
import { Store } from '@ngrx/store';
import { MAP_SETUP_PATH, WIDGET_SETUP_PATH, INTEGRATE_SETUP_PATH } from './constants';
import { widgetSaveSettings, widgetSkip } from '../../widget/state/widget_actions';
import { Router } from '@angular/router';
import { REDCRSS_EVENTS } from '../../../shared/services/constants/redcross_evemts';
import { FeatureService } from '../services/feature.service';
import { ShopifyService } from '../services/shopify.service';
import { mapSaveData, mapSkip } from '../../map/state/map-actions-creator';
import { navActivateNextStep, navFinishInstallation, navSetActiveStep } from './state/navigation_actions_creator';
import { IAppState } from '../../../app_state';
import { AnalyticsTrackingProvider } from '@yotpo-ui/core';
import { take } from 'rxjs/operators';

@Component({})
export abstract class NavButtonsComponent {

  currentStep: NavigationItem;
  isWidgetV3: boolean;

  constructor(protected redCross: AnalyticsTrackingProvider,
              protected store: Store<IAppState>,
              protected router: Router,
              protected featureService: FeatureService,
              protected shopifyService: ShopifyService) {
    this.store.select(state => state.app.install.navigation).subscribe(
      items => {
        this.currentStep = items.navigationItems.filter(item => item.active === true)[0];
      });
    this.store.select(state => state.app.install.integrate).pipe(take(1)).subscribe(
      items => {
        this.isWidgetV3 = items.hasWidgetV3;
      });
  };

  nextClickedOn() {
    this.redCross.track(REDCRSS_EVENTS.CTA_CLICK, {
      ctaType: 'Button',
      ctaText: 'Next'
    });

    switch (this.currentStep.url) {

      case MAP_SETUP_PATH: {
        this.store.dispatch(mapSaveData());
        break;
      }

      case WIDGET_SETUP_PATH: {
        this.store.dispatch(widgetSaveSettings());
        break;
      }
    }

    this.store.dispatch(navActivateNextStep({finishedStep: this.currentStep}));
    this.store.dispatch(navSetActiveStep({activeStep: this.currentStep.nextStep}));
  }

  backClickedOn() {
    this.redCross.track(REDCRSS_EVENTS.CTA_CLICK, {
      ctaType: 'Button',
      ctaText: 'Back'
    });

    let phaseStep;

    switch (this.currentStep.url) {

      case WIDGET_SETUP_PATH: {
        phaseStep = 2;
        break;
      }

      case INTEGRATE_SETUP_PATH: {
        phaseStep = 3;
        break;
      }
    }

    this.redCross.track(REDCRSS_EVENTS.ONBOARDING, {
      category: 'Reviews',
      phaseName: 'Onboarding Step ' + phaseStep,
      phase: phaseStep,
      status: 'back'
    });

    this.store.dispatch(navSetActiveStep({activeStep: this.currentStep.prevStep}));
  }

  skipClickedOn() {
    this.redCross.track(REDCRSS_EVENTS.CTA_CLICK, {
      ctaType: 'Button',
      ctaText: 'Skip Step'
    });

    this.featureService.setFeatureSettings('InstallationV2',
      {
        settings: {
          install_status: 'Skipped'
        }
      }
    ).subscribe();

    switch (this.currentStep.url) {

      case MAP_SETUP_PATH: {
        this.store.dispatch(mapSkip());
        break;
      }

      case WIDGET_SETUP_PATH: {
        this.store.dispatch(widgetSkip());
        break;
      }
    }

    this.store.dispatch(navSetActiveStep({activeStep: this.currentStep.nextStep}));
  }

  finishInstallShopify() {
    this.redCross.track(REDCRSS_EVENTS.ACTIVATION_STEP, {
      product: REDCRSS_EVENTS.PRODUCT,
      stepName: 'Install Widget',
      stepNum: 3,
      status: 'Completed',
      isWidgetV3: this.isWidgetV3,
      os20: true
    });
    this.store.dispatch(navFinishInstallation({finishedStep: this.currentStep}));
  }

  finishInstallClicked() {
    this.redCross.track(REDCRSS_EVENTS.CTA_CLICK, {
      ctaType: 'Button',
      ctaText: 'Finish'
    });

    this.redCross.track(REDCRSS_EVENTS.ONBOARDING, {
      category: 'Reviews',
      phaseName: 'Onboarding Step 3',
      phase: 3,
      status: 'completed',
      ctaText: 'manual'
    });

    this.store.dispatch(navFinishInstallation({finishedStep: this.currentStep}));
  }

  finishInstallShopifyOpenTab() {
    this.shopifyService.shopDeeplink().subscribe(data => {
      this.redCross.track(REDCRSS_EVENTS.BUTTON_CLICK, {
        product: REDCRSS_EVENTS.PRODUCT,
        btnContext: 'Reviews Activation',
        btnLocation: 'Onboarding Install Widget',
        btnName: 'Shopify Theme Editor',
        btnText: 'Shopify Theme Editor from here',
        os20: true
      });
      window.open(data.response, '_blank');
    });
  }

  showBackButton() {
    return this.currentStep.prevStep;
  }
}
